import { BaseError } from '.';

export class ApiError extends BaseError {}

export class ApiFetchError extends ApiError {}
